import { action, computed, makeObservable, observable } from 'mobx';

export interface AuthState {
  token: string;
  expiresAt: number;
}

class UserStore {
  token: string | null = null;
  expiresAt: number | null = null;
  isInitialising = true;

  constructor() {
    makeObservable(this, {
      token: observable,
      expiresAt: observable,
      isInitialising: observable,
      isAuthenticated: computed,
      setAuth: action,
      clearAuth: action,
      setInitialising: action,
    });
  }

  get isAuthenticated(): boolean {
    return Boolean(this.token);
  }

  setAuth({ token, expiresAt }: AuthState): void {
    this.token = token;
    this.expiresAt = expiresAt;
  }

  clearAuth(): void {
    this.token = null;
    this.expiresAt = null;
  }

  setInitialising(isInitialising: boolean): void {
    this.isInitialising = isInitialising;
  }
}

export const userStore = new UserStore();
